import { useQuery } from '@tanstack/react-query';
import { CompanyContext } from 'contexts/CompanyContextProvider';
import useCurrentUser from 'hooks/useCurrentUser';
import { useContext } from 'react';
import { QUERY_KEYS } from 'services/api/constants';
import CompanyService from 'services/CompanyService';

type Result = { status: 'pending' } | { status: 'error' } | { status: 'ready'; hasAccess: boolean };

export default function useHeaderAccessToCompanySettings(): Result {
  const currentUser = useCurrentUser();
  const { companyId } = useContext(CompanyContext);
  const accessToEditQuery = useQuery({
    queryFn: () => CompanyService.getAccessToEdit(companyId!),
    queryKey: [QUERY_KEYS.COMPANY_ACCESS_TO_EDIT, companyId, currentUser.id],
    enabled: !!companyId,
  });

  if (!!companyId && accessToEditQuery.isPending) {
    return { status: 'pending' };
  }

  if (accessToEditQuery.error) {
    return { status: 'error' };
  }

  return { status: 'ready', hasAccess: accessToEditQuery.data! };
}
